import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { brandLogoSrc } from '../api';
import SimulAlertLogo from '../images/LogoWhiteBackground.png';

/**
 * The school's logo where it has one, the SimulAlert logo otherwise, and
 * the SimulAlert logo again if the school's fails to load.
 *
 * A school's logo is drawn larger than SimulAlert's, since it often carries
 * the school's name in small type. School logos are made for white paper, so
 * one sits on a white plate wherever the header is not white paper: on the
 * night theme, and on a header painted in the school's colour.
 */
function BrandLogo({ logoUrl, night, branded, height = 32, schoolHeight = 44 }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [logoUrl]);

  const school = !failed ? brandLogoSrc(logoUrl) : null;
  const plate = school && (night || branded);
  return (
    <img
      src={school ?? SimulAlertLogo}
      alt={school ? 'School logo' : 'SimulAlert'}
      onError={() => setFailed(true)}
      style={{
        height: school ? schoolHeight : height,
        width: 'auto',
        maxWidth: 220,
        objectFit: 'contain',
        display: 'block',
        boxSizing: 'border-box',
        background: plate ? '#ffffff' : 'transparent',
        padding: plate ? '3px 8px' : 0,
        borderRadius: plate ? 6 : 0
      }}
    />
  );
}

BrandLogo.propTypes = {
  logoUrl: PropTypes.string,
  night: PropTypes.bool,
  branded: PropTypes.bool,
  height: PropTypes.number,
  schoolHeight: PropTypes.number
};

const mapStateToProps = (state) => ({
  logoUrl: state.brand?.logoUrl ?? null,
  night: state.theme?.mode === 'night',
  branded: state.brand?.accentColor != null
});

export default connect(mapStateToProps)(BrandLogo);
